export default __webpack_public_path__ + "static/media/ic_trash_danger.ed1e17f7.svg";